import { render, staticRenderFns } from "./UpsertAppModal.vue?vue&type=template&id=956b5906&"
import script from "./UpsertAppModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertAppModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports